import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { Credential } from '../../model/credential';
import { HttpClient } from '@angular/common/http';
import { CuadernilloOffline } from 'src/app/model/cuadernilloOffline';
import { ConfiguracionDTO } from 'src/app/model/configuracion.dto';
import { WelcomeDTO } from "../../model/welcome.info";
import { Item } from 'src/app/model/item';
import { Token } from "../../model/token";
import { ItemService } from '../../services/item/item.service';
import { AnswerControlService } from '../answer/answerControl.service';
import { ItemControlService } from "../../services/item/item-control.service";
import { ConfigurationControlService } from "../../services/configuration/configurationControl.service";

@Injectable({
  providedIn: 'root'
})
export class OfflineService {
  private folderCredential = "/src/assets/data/credenciales.json";
  private folderItems = "/src/assets/data/items.json";
  private folderCuadernillo = "/src/assets/data/cuadernillos.json";
  private folderConfig = "/src/assets/data/configuracion.json";


  public credential: Credential = null;
  public welcomeDTO: WelcomeDTO;

  constructor(private http: HttpClient,
      private _itemService: ItemService,
      private _answerController: AnswerControlService,
      private _itemControlService: ItemControlService,
      private _configurationControlService: ConfigurationControlService) {
  }

  private getFilterItemsByIdCombo(listaItemsAll: Item[], idCombo:string){
    const listaItems: Item[] = [];
    const listaTotalChildBySesion = [];
    const listaTotalBySesion = [];
    listaItemsAll.forEach((item) => {
        if(item.idcombo == idCombo) {
            listaItems.push(item);
            if(listaTotalBySesion[item.sesion] === undefined ){
                listaTotalBySesion[item.sesion] = 0;
            }
            if(listaTotalChildBySesion[item.sesion] === undefined ){
                listaTotalChildBySesion[item.sesion] = 0;
            }
            listaTotalBySesion[item.sesion] ++;
            listaTotalChildBySesion[item.sesion] +=  item.itemChild == 0 ? 1 : item.itemChild;
        }
    });
    listaItems.forEach((item) => {
        item.totalVisual = listaTotalChildBySesion[item.sesion];
        item.total = listaTotalBySesion[item.sesion];
    });

    return listaItems;
  }

  public getItems(idToken, token): Promise<Item[]> {
      let self = this;
      return new Promise(resolve => {
          this.http.get(this.folderItems).subscribe(data => {
              let listaItems: Item[] = [];
              listaItems = JSON.parse(this.decrypt(data['data']));
              listaItems = this.getFilterItemsByIdCombo(listaItems, this.welcomeDTO.idCombo);
              self._itemControlService.totalItems = listaItems;
              self._answerController.totalItems = listaItems.length;
             
              resolve(listaItems)
          }, err => {
              resolve(null);
          })
      })

  }

  public getConfigiracionExamen(idCombo: any, token: string, user: string): Promise<ConfiguracionDTO> {
      return new Promise(resolve => {
          this.http.get(this.folderConfig)
              .toPromise()
              .then(data => {
                  try {
                      let listaConfiguracion = <ConfiguracionDTO[]>JSON.parse(this.decrypt(data['data']));
                      //listaConfiguracion[0].downloadAnswer = true;
                      listaConfiguracion[0].multiplesesion = true;
                      resolve(listaConfiguracion[0]);
                 } catch (e) {
                      console.error(e);
                  }
                  resolve(null);
              });
      })
  }

  public getCuadernillo(): Promise<CuadernilloOffline[]> {
      return this.http.get(this.folderCuadernillo)
          .toPromise()
          .then(data => {
              let lista = new Array<CuadernilloOffline>();
              try {
                  lista = <CuadernilloOffline[]>JSON.parse(this.decrypt(data['data']));
              } catch (e) {
                  console.error(e);
              }

              return lista;
          });
  }


  public loginOffline(user: String, password: String): Promise<Token> {
      return new Promise( (resolve,reject) => {
          this.getCredential().then(
              (listaCredentials) => {
                  console.log("credenciales", listaCredentials);
                  this.credential = null;
                  const credentialFind = listaCredentials.find((credential) => {
                    if (user.toLowerCase() === credential.usuario.toLowerCase() && password.toLowerCase() === credential.password.toLowerCase()) {
                          return true;
                      }
                      return false;
                  });
                  if (credentialFind) {
                      credentialFind.configuracionUsuarioObject = JSON.parse(credentialFind.configuracionUsuario.toString());
                      this.credential = credentialFind;
                      resolve(new Token(
                          '',//
                          1, //estado
                          '',//token,
                          credentialFind.idCredencial, //credentialId
                          credentialFind.tipoUsuario,
                          '',// message
                          1,//loginFlag
                          1,//sesion
                          '', //uid
                          0, //cantidad sesiones
                          ''
                      ));
                    }else {
                        reject(null);
                    }
              }
          );
      })
  }

  public async getWelcomeDTO(userId: number, token: string, userName: string, sesion: number = 1): Promise<any> {
      return new Promise(resolve => {
          this.getCuadernillo().then(listCuadernillo => {
              console.log('cuadernillos', listCuadernillo);
              const cuadernillo = listCuadernillo.find(cuadernillo => {
                  console.log(`id ${cuadernillo.idCombo} == ${this.credential.idCombo}`);
                  if (cuadernillo.idCombo === this.credential.idCombo) {
                      return true;
                  }
                  return false;
              });

              if (cuadernillo) {
                  let config = this.credential.configuracionUsuarioObject;
                  this.welcomeDTO = new WelcomeDTO(
                      config.fullName,
                      config.institution,
                      config.daneCode,
                      config.modality,
                      config.test,
                      false, //credentialSlack
                      "",//aplicationType
                      "",//saberCode
                      false,//credential_S359
                      this.credential.configuracionUsuarioObject.identificacion,
                      "",//mail
                      "",//registro
                      this.credential.idCombo,
                      cuadernillo.sessions,
                      cuadernillo.TipoItems,
                      this.credential.configuracionUsuarioObject.shortName,
                      false,//discapacidad
                      "", //idCurso
                      "",
                  );
              }
              for(let sesion of this.welcomeDTO.sessions){     
                  sesion.showButton = true;
                  sesion.disabledButton = true;
                  sesion.buttonAction = "Iniciar"
              }
              if(this.welcomeDTO.sessions.length >= sesion){
                const positionSesion = sesion -1;
                this.welcomeDTO.sessions[positionSesion].showButton = true;
                this.welcomeDTO.sessions[positionSesion].disabledButton = false;
                this.welcomeDTO.sessions[positionSesion].buttonAction = "Iniciar";
              } 
              console.log("welcomeDTO ...", this.welcomeDTO)
              resolve(this.welcomeDTO);
          })
      })
  }

  public getCredential(): Promise<Array<Credential>> {
      return this.http.get(this.folderCredential)
          .toPromise()
          .then(data => {
           return  this.getMapperCredential( <Array<any>>data)
        });
  }


  public getMapperCredential(content: Array<any>): Array<Credential> {
    let listCredial = new Array<Credential>();
    try {
        for (const obj of content) {
            const data = this.decrypt(obj['data']); 
            const credentials = < Array<Credential>>JSON.parse(data);
            listCredial = listCredial.concat(credentials);    
        }

    }catch(e){
        console.error('Error getcredential :' + e);
        
    }
 

      return listCredial;
  }

  public decrypt(content: any) {
      const contenidoItem = content.substring(0, content.length - 44);
      const keyItem = content.substring(content.length - 44, content.length);
      const key = CryptoJS.enc.Base64.parse(keyItem);

      const decryptedData = CryptoJS.AES.decrypt(contenidoItem, key, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
      });
      let a = decryptedData.toString(CryptoJS.enc.Utf8);

      return a;
  }
}
